var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2162 30.3505H3.70013C2.17801 30.3505 0.943359 29.25 0.943359 27.8934V12.8421C0.943359 11.4854 2.17801 10.385 3.70013 10.385H31.2162C32.7383 10.385 33.973 11.4854 33.973 12.8421V27.8934C33.973 29.25 32.7383 30.3505 31.2162 30.3505Z",
    fill: "#00AAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1176 5.66138H6.72684C5.45165 5.66138 4.41602 6.58443 4.41602 7.72099V9.33058H30.4284V7.72099C30.4284 6.58114 29.3928 5.66138 28.1176 5.66138Z",
    fill: "#FC592D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.647 0.888428H9.34598C8.07079 0.888428 7.03516 1.81148 7.03516 2.94804V4.55763H27.9615V2.94804C27.9579 1.81148 26.9259 0.888428 25.647 0.888428Z",
    fill: "#FFCE00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductListIcon);
export default __webpack_public_path__ + "static/media/Product_list_icon.13f69e073cb2a92f9c09abb3c4ed37c9.svg";
export { ForwardRef as ReactComponent };